import { Pipe, PipeTransform } from '@angular/core';
import { DataUnitsTransform } from 'src/app/lib/data-units';

@Pipe({
    name: 'dataUnits',
    standalone: true,
})
export class DataUnitsPipe implements PipeTransform {
  transform(value: number, startUnitIndex = 0, decimals = 0, maxLength?: number): string {
    return DataUnitsTransform(value, startUnitIndex, decimals, maxLength);
  }
}
